module.exports = __webpack_public_path__ + "img/icon_noReceipt.a47d27ca.svg";